/**
 * 変数定数
 * アプリケーション全体で使用される共通の変数値を定義する
 */

/** メモの最大文字数制限 */
export const MAX_CHARACTERS_MEMO = 300;
